import type { SVGProps } from 'react'
import * as React from 'react'

const book = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={18} height={20} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.0418 0H2.14883C0.966972 0 0 0.9 0 2V18C0 19.1 0.966972 20 2.14883 20H15.0418C16.2236 20 17.1906 19.1 17.1906 18V2C17.1906 0.9 16.2236 0 15.0418 0ZM2.14883 2H7.5209V10L4.83486 8.5L2.14883 10V2Z"
      fill="#1B1C1F"
    />
  </svg>
)

export default book
